// Timeout for voice.finalize_recording fetch.
// 2026-04-20: bumped from 90s → 240s. Conversation-mode recordings produce
// 1.5s chunks, so an 81-second dictation = 54 chunks. Even at 10-wide
// parallel (VOICE_FINALIZE_MAX_PARALLEL) that's ~60–90s server-side. The
// previous 90s cap aborted the client mid-pipeline and surfaced as "timed
// out" on recordings that would have completed at ~100s. 240s leaves
// headroom under Vercel's 300s function budget and matches the server's
// actual upper bound.
export const FINALIZE_TIMEOUT_MS = 240_000;

// TICKET-047 (AEGIS audit 2026-05-01) — chunk + partial-transcript fetches in
// useWhisperRecording.js shipped without AbortSignal.timeout. A hung request
// pinned the recording state at "Transcribing audio…" forever (TICKET-024B).
//
// CHUNK_UPLOAD_TIMEOUT_MS: 60s upload of a single 60s dictation chunk to
// /api/ai voice.upload_chunk. Allows for network jitter on mobile + Whisper
// processing slack. Larger than the chunk duration so a slow but progressing
// upload isn't aborted prematurely. The hook already has UPLOAD_RETRIES=3
// linear backoff above this layer.
export const CHUNK_UPLOAD_TIMEOUT_MS = 60_000;

// PARTIAL_TRANSCRIPT_TIMEOUT_MS: 15s for conversation-mode 1.5s chunks. These
// must complete fast or be dropped — they're preview text, never the source
// of truth (the dictation chunk path is the real transcript). 15s gives enough
// headroom for cold Whisper warmup but won't pin the UI on a stuck request.
export const PARTIAL_TRANSCRIPT_TIMEOUT_MS = 15_000;

// Classify a finalize fetch error into a staged outcome so the UI can show
// the user what actually went wrong (we timed out vs the provider failed
// vs the network dropped) instead of a single opaque "try again" toast.
export function classifyFinalizeError(err) {
  if (!err) {
    return { stage: 'network', message: 'Transcription failed' };
  }
  const name = err.name || '';
  const message = err.message || 'Transcription failed';

  if (name === 'AbortError') {
    return {
      stage: 'timeout',
      message:
        'Transcription timed out after 4 min — recording saved, try again',
    };
  }

  if (/\bHTTP\b/i.test(message) || /\(\d{3}\)/.test(message)) {
    return { stage: 'provider', message };
  }

  return { stage: 'network', message };
}
